



















































import { Vue, Component } from 'vue-property-decorator'
import validation from '../../common/element-val'
import auth, { LogModel } from '../../services/authService'
import store from '../../store'
import { User } from '@/services/data'
import { VForm } from '@/services/VForm'

@Component
export default class Login extends Vue {
  $refs!: {
    loginForm: VForm;
    username: any;
  }

  isLoading = false
  login: LogModel = {
    Email: '',
    Password: '',
    Language: 'en',
    RememberMe: false
  }

  rules = {
    email: validation.email(this.$t('val.invalid') as string),
    required: validation.required(this.$t('val.required') as string)
  }

  async mounted () {
    if (process.env.NODE_ENV === 'dev') {
      this.login.Email = ''
    }
    document.onkeydown = e => {
      const _key = e.keyCode
      if (_key === 13) {
        this.submit()
      }
    }
    this.$nextTick(() => this.$refs.username.focus())
  }

  changeLang () {
    this.$i18n.locale = this.login.Language
  }

  async submit () {
    if (!this.$refs.loginForm.validate()) return
    this.isLoading = true
    try {
      const res = await auth.loginAsync(this.login)
      this.isLoading = false
      if (res.Error) {
        await this.$alert(this.$t('msg.' + res.Error) as string)
        return
      }
      const result = res.Result
      const jwt = result.jwt
      if (jwt) {
        const userString = decodeURIComponent(escape(window.atob(jwt.split('.')[1])))
        const user = JSON.parse(userString)
        const userData: User = {
          email: user.LoginId,
          name: user.Name,
          accNo: user.AccNo,
          jwt: jwt
        }
        store.commit('setUser', userData)
        sessionStorage.setItem('chromeToken', result.chromeToken)
        if (this.login.RememberMe) {
          localStorage.setItem('jwt', result.jwt)
        } else {
          sessionStorage.setItem('jwt', result.jwt)
        }
        await this.$router.push('/home/dashboard')
      }
    } catch (e) {
      this.isLoading = false
      await this.$alert(e.Error)
    }
  }
}
